$ ->
  if $('.elm_application').length > 0
    elm = require('../../../../elm/elm.js')
    $('.elm_application').each ->
      el = $(this)
      app = elm[el.data('name')].embed(el.get()[0], el.data('flags'))
      el.trigger 'elm_init', app
